const appThemeConfig = {
  cookieBotId: "b66ede31-4817-4c2b-a4dd-e671cc93f4e0",
  login: "Login",
  showLogo: false,
  hasBackgrounds: false,
  contactEmail: "support@whycatcher.com",
  communityName: "Whycatcher | Participant portal",
  privacy: "/pages/privacy-policy",
  terms: "/pages/terms-conditions",
  enableDashboardStats: true,
  showUserSettingsPayment: true,
  participantMenu: [  {
    title: "Settings",
    url: "theme-participant-user-settings",
    icon: "fa-cog",
  }],
  sideMenu: {
    dashboardEnabled: true,
    dashboardName: "Dashboard",
    aboutEnabled: false,
    FAQEnabled: false,
    newsEnabled: false,
    contactEnabled: true
  },
  images: {
    backgrounds: {
      url: "/themes/wwf/images/spring/1.jpg"
    },
    aboutImage: [
      {
        url: "/themes/app/pages/hero/about.jpg",
      },
    ],
  },
  tinyMce: {
    content_style:
      "body { color: #7c7c7c; font-size: 14px; font-family: Arial; }",
  },
  dailyCall: {
    style: {
      accent: "#034C52", // Main theme color. Used for primary actions and keyboard focus.
      accentText: '#ffffff', // Text color rendered on accent.
      background: '#fbfbfb', // Background color.
    },
  },

};

export default appThemeConfig;
